// extracted by mini-css-extract-plugin
export default {"BottleContainer":"BottleListItem_BottleContainer__3yJqX","Image":"BottleListItem_Image__7pdL+"};